import { useEffect, useState } from "react";
import { useAllPropertiesMarkers } from "../../hooks/properties/useAllPropertiesMarkers";
import { useListCollections } from "../../hooks/properties/useListCollections";
import PropertyMap from "../common/PropertyMap";

type PropertyOverviewMapProps = {
  propertyFilter: any;
  mapTypeName?: string;
};

const PropertyOverviewMap = ({
  propertyFilter,
  mapTypeName,
}: PropertyOverviewMapProps) => {
  const [data, setData] = useState<any>([]);
  const { getDataByFilter: getMapMarkersByFilter, data: propertyData } =
    useAllPropertiesMarkers();
  const {
    getDataByFilter: getCollectionMapMarkersByFilter,
    data: collectionData,
  } = useListCollections();

  useEffect(() => {
    const mapFilterPayload = propertyFilter;
    mapFilterPayload.pageIndex = 0;
    mapFilterPayload.pageSize = 999999;
    if (mapTypeName === "collections") {
      getCollectionMapMarkersByFilter(mapFilterPayload);
    } else {
      getMapMarkersByFilter(mapFilterPayload);
    }
  }, [propertyFilter]);

  useEffect(() => {
    if (collectionData) {
      const mappedCollections = collectionData?.collections?.map(
        (collection: any) => {
          return {
            ...collection,
            longitude: collection.propertyDetails.longitude,
            latitude: collection.propertyDetails.latitude,
          };
        },
      );
      setData(mappedCollections);
    }
    if (propertyData?.properties?.length > 0) {
      setData(propertyData?.properties);
    }
  }, [propertyData, collectionData]);

  return (
    <>
      <PropertyMap
        sx={{
          height: { xs: "60vh", sm: "60vh", md: "70vh" },
        }}
        propertyData={data}
      />
    </>
  );
};

export default PropertyOverviewMap;
